import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import SoKnoLanding from "@/components/SoKnoLanding";
import SkipLink from "@/components/SkipLink";
import AnalyticsRouteListener from "@/components/AnalyticsRouteListener";
import {
  PRODUCTION_NETWORK_LEGACY_PATH,
  PRODUCTION_NETWORK_PATH,
} from "@/constants/navLinks";

const AdminPage = lazy(() => import("@/pages/Admin"));
const PrivacyPage = lazy(() => import("@/pages/Privacy"));
const ProductionNetworkPage = lazy(() => import("@/pages/ProductionNetwork"));
const ProjectsIndexPage = lazy(() => import("@/pages/ProjectsIndex"));
const ProjectDetailPage = lazy(() => import("@/pages/ProjectDetail"));
const PressPage = lazy(() => import("@/pages/Press"));
const NotFoundPage = lazy(() => import("@/pages/NotFound"));
const SubmitHubPage = lazy(() => import("@/pages/SubmitHub"));
const TalentSubmitPage = lazy(() => import("@/pages/TalentSubmit"));
const ProjectSubmitPage = lazy(() => import("@/pages/ProjectSubmit"));
const PartnerSubmitPage = lazy(() => import("@/pages/PartnerSubmit"));
const ContactSubmitPage = lazy(() => import("@/pages/ContactSubmit"));

function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: "40vh",
        display: "grid",
        placeItems: "center",
        color: "var(--sokno-cream-dim)",
        fontSize: 14,
      }}
    >
      Loading…
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SkipLink />
        <AnalyticsRouteListener />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<SoKnoLanding />} />
            <Route path="/projects" element={<ProjectsIndexPage />} />
            <Route path="/projects/:slug" element={<ProjectDetailPage />} />
            <Route path="/press" element={<PressPage />} />
            <Route path="/submit" element={<SubmitHubPage />} />
            <Route path="/submit/talent" element={<TalentSubmitPage />} />
            <Route path="/submit/project" element={<ProjectSubmitPage />} />
            <Route path="/submit/partner" element={<PartnerSubmitPage />} />
            <Route path="/submit/contact" element={<ContactSubmitPage />} />
            <Route path={PRODUCTION_NETWORK_PATH} element={<ProductionNetworkPage />} />
            <Route
              path={PRODUCTION_NETWORK_LEGACY_PATH}
              element={<Navigate to={PRODUCTION_NETWORK_PATH} replace />}
            />
            {/* Legacy home-hash form deep links → dedicated form routes */}
            <Route path="/casting" element={<Navigate to="/submit/talent" replace />} />
            <Route path="/partner" element={<Navigate to="/submit/partner" replace />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
